const BASE_URL = process.env.REACT_APP_API_KEY;


export const IMAGE_CATEGORY_ROOT_URL: string = BASE_URL+`/categories/api/`;
export const IMAGE_POPUP_ROOT_URL: string=BASE_URL+'/api/';
export const IMAGE_MERCHANT_ROOT_URL : string = BASE_URL+'/merchant/api/';
export const IMAGE_PRODUCTS_ROOT_URL:string=BASE_URL+'/products/api/';


export const IMAGE_RIDER_ROOT_URL:string = BASE_URL + '/profile/api/'

export const IMAGE_MERCHANT_URL : string = BASE_URL + '/merchant/api/';
export const IMAGE_ORDER_URL : string = BASE_URL + '/order/api/';